import React from "react";
import styled from "styled-components";

import logo from "../assets/authors/logo.png";
import author1 from "../assets/authors/author-1.png";
import author2 from "../assets/authors/author-2.png";
import author3 from "../assets/authors/author-3.png";
import author4 from "../assets/authors/author-4.png";

const SectionAuthorsWrapper = styled.div`
  padding-bottom: 120px;
  position: relative;

  .row {
    overflow: hidden;
    > img {
      position: absolute;
      top: 250px;
      left: -40px;
      z-index: 10;
      width: 108%;

      @media (max-width: 991.98px) {
        left: 0;
        width: 100%;
      }

      @media (max-width: 767.98px) {
        display: none;
      }
    }
  }

  .borderss {
    width: 100%;
    .border-top {
      color: #ff5000;
      font-family: "Roboto Mono";
      font-size: 20px;
      text-transform: uppercase;
      font-weight: 400;
      letter-spacing: 5px;
      display: block;
      width: 100%;
      max-width: 1110px;
      margin: 0 auto 140px;
      padding-top: 30px;
    }
  }
`;

const Author = styled.div`
  margin-bottom: 30px;

  img {
    width: 100%;
    margin-bottom: 30px;
  }
  p {
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 0;
    font-family: "Roboto Mono";
    text-transform: uppercase;
  }
  span {
    font-size: 10px;
    line-height: 10px;
    color: #8f9092;
    font-family: "Roboto Mono";
    text-transform: uppercase;
  }
`;

const SectionAuthors = () => {
  return (
    <SectionAuthorsWrapper className="container container-small section-car-text">
      <div className="row">
        <img src={logo} alt="" />
        <div className="borderss col-10 offset-1">
          <h6 className="border-top">Poznaj V1RAGE</h6>
        </div>
        <Author className="col-10 offset-1 col-sm-6 offset-sm-0 col-md-3">
          <img src={author1} alt="" />
          <p>Adam Kowalski</p>
          <span>Prezes zarządu</span>
        </Author>
        <Author className="col-10 offset-1 col-sm-6 offset-sm-0 col-md-3">
          <img src={author2} alt="" />
          <p>Mariusz nowak</p>
          <span>v. Prezes</span>
        </Author>
        <Author className="col-10 offset-1 col-sm-6 offset-sm-0 col-md-3">
          <img src={author3} alt="" />
          <p>monika szydło</p>
          <span>dyrektor</span>
        </Author>
        <Author className="col-10 offset-1 col-sm-6 offset-sm-0 col-md-3">
          <img src={author4} alt="" />
          <p>RObert Król</p>
          <span>Dyrektor</span>
        </Author>
      </div>
    </SectionAuthorsWrapper>
  );
};

export default SectionAuthors;
